import { type Customer, PrepaymentRequirementEnum } from '@/types';

export const requiresFullPrepayment = (
  customer: Pick<Customer, 'prepaymentRequirement'>,
): boolean => customer.prepaymentRequirement === PrepaymentRequirementEnum.Full;

export const prepaymentRequirementFor = (
  requiresFull: boolean,
): PrepaymentRequirementEnum | null =>
  requiresFull ? PrepaymentRequirementEnum.Full : null;
